let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bs9oy")).then(() => parcelRequire('iHbmF'));